<!--
* UI Name: Add user
* Modify Date: 2020/06/18
-->
<template>
  <v-card class="v-modal-new-window analyzed-dialog analyzed-view-dialog">
    <!-- [S]  Popup title-->
    <v-card-title class="headline white--text" primary-title>
      {{ `${options.isEdit ? 'Modify' : 'Add'} User` }}
    </v-card-title>

    <!-- [S]  Popup body-->
    <v-card-text class="user-data-section">
      <v-row class="ml-0 mr-0 mb-1">
        <v-col cols="5" class="pa-0 text-base process-text-info">
          {{ $t('lbl.users.addUser.header') }}
        </v-col>
        <v-col cols="7" class="pr-0 pt-0 pb-0 text-base process-text-info">
          {{ $t('lbl.users.addUser.menu') }} &amp; {{ $t('lbl.users.addUser.buttonRole') }}
        </v-col>
      </v-row>
      <!-- [S]  Right Form-->
      <v-row class="ml-0 mr-0 mb-1">
        <v-col cols="5" class="pl-0">
          <v-form ref="form" class="dialog-content form-user ml-0">
            <v-row class="ml-0 mr-0 mb-1">
              <v-col cols="12" class="pl-1 pa-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.users.addUser.userId') }}</v-label
                >
                <v-text-field
                  v-model="editedItem.usrId"
                  :rules="[
                    validationUtils.required,
                    validationUtils.emailIdRules,
                    validationUtils.max(35),
                  ]"
                  :readonly="options.isEdit"
                  :disabled="!$auth.manage"
                  ref="usrId"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ml-0 mr-0 mb-1">
              <v-col cols="12" class="pl-1 pa-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.users.addUser.companyName') }}</v-label
                >
                <v-autocomplete
                  v-model="editedItem.compId"
                  :items="compList"
                  :menu-props="{ offsetY: true }"
                  :rules="[validationUtils.required]"
                  :disabled="!$auth.manage"
                  class="custom-selectbox"
                  dense
                ></v-autocomplete>
              </v-col>
              <!-- <v-col v-if="!options.isEdit" cols="5" class="pl-1 pa-0">
                <v-checkbox
                  v-model="editedItem.verifyEmail"
                  :disabled="!$auth.manage"
                  label="Verify Email"
                  dense
                  hide-details="true"
                ></v-checkbox>
              </v-col> -->
            </v-row>
            <v-row class="ml-0 mr-0  mb-1">
              <v-col cols="12" class="pl-1 pa-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.users.addUser.userName') }}</v-label
                >
                <v-text-field
                  v-model="editedItem.usrNm"
                  :rules="[validationUtils.required, validationUtils.max(50)]"
                  :disabled="!$auth.manage"
                  ref="usrNm"
                  dense
                  autocomplete="off"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ml-0 mr-0 mb-1">
              <v-col cols="12" class="pl-1 pa-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.users.addUser.password') }}</v-label
                >
                <v-row class="ml-0 mr-0 mb-1">
                  <v-col cols="12" class="pl-1 pa-0 d-inline-flex">
                    <v-text-field
                      v-model="editedItem.usrPwd"
                      :rules="[validationUtils.passwordRules]"
                      :disabled="!$auth.manage"
                      ref="usrPwd"
                      dense
                      type="password"
                      autocomplete="new-password"
                      :maxlength="20"
                    ></v-text-field>
                    <v-tooltip top :max-width="tooltipWidth" style="questionToolTip">
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-icon class="btn-tooltip-pw">
                            far fa-question-circle
                          </v-icon>
                        </div>
                      </template>
                      <span v-html="$t('msg.users.questionIconTooltip')"> </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="ml-0 mr-0 mb-1">
              <v-col cols="12" class="pl-1 pa-0">
                <v-label>{{ $t('lbl.users.addUser.phone') }}</v-label>
                <v-text-field
                  v-model="editedItem.compTelNo"
                  :rules="editedItem.compTelNo ? [validationUtils.max(50)] : []"
                  :disabled="!$auth.manage"
                  ref="compTelNo"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ml-0 mr-0 mb-1">
              <v-col cols="7" class="pl-1 pa-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.users.addUser.country') }}</v-label
                >
                <v-autocomplete
                  v-model="editedItem.langTpCd"
                  :items="langTpCdList"
                  :menu-props="{ offsetY: true }"
                  :rules="[validationUtils.required]"
                  :disabled="!$auth.manage"
                  @change="selectCountry()"
                  class="custom-selectbox"
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="5" class="pl-1 pa-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.users.addUser.timeZone') }}</v-label
                >
                <v-select
                  v-model="editedItem.gmtTmznCd"
                  :items="gmtTmznCdList"
                  :menu-props="{ offsetY: true }"
                  :rules="[validationUtils.required]"
                  :disabled="!$auth.manage"
                  class="custom-selectbox"
                  ref="gmtTmznCd"
                  dense
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="ml-0 mr-0 mb-1">
              <v-col cols="7" class="pl-1 pa-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.users.addUser.role') }}</v-label
                >
                <v-select
                  v-model="editedItem.useGrdCd"
                  :items="useGrdCdList"
                  :menu-props="{ offsetY: true }"
                  :rules="[validationUtils.required]"
                  :disabled="!$auth.manage"
                  @change="changeRole(editedItem.useGrdCd)"
                  class="custom-selectbox"
                  ref="useGrdCd"
                  dense
                ></v-select>
              </v-col>
              <v-col cols="5" class="pl-1 pa-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.users.addUser.screenTheme') }}</v-label
                >
                <v-select
                  v-model="editedItem.selUiThmCd"
                  :items="selUiThmCdList"
                  :menu-props="{ offsetY: true }"
                  :rules="[validationUtils.required]"
                  :disabled="!$auth.manage"
                  class="custom-selectbox"
                  ref="selUiThmCd"
                  dense
                ></v-select>
              </v-col>
            </v-row>
            <v-row
              v-if="
                (Number(this.$cookies.get('use-grade')) === 3 ||
                  Number(this.$cookies.get('use-grade')) === 9) &&
                  options.isEdit
              "
              class="ml-0 mr-0 mb-1"
            >
              <v-col cols="7" class="pl-1 pa-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.users.addUser.emailVerification') }}</v-label
                >
              </v-col>
              <v-col cols="5" class="pl-1 pa-0"> </v-col>
              <v-col cols="7" class="pl-1 pa-0">
                <v-select
                  v-model="editedItem.authCd"
                  :items="emailVrfSttList"
                  :menu-props="{ offsetY: true }"
                  :rules="[validationUtils.required]"
                  class="custom-selectbox"
                  dense
                  readonly
                ></v-select>
              </v-col>
              <v-col cols="5" class="pl-1 pa-0">
                <div class="btn-form-control text-right">
                  <v-btn
                    v-if="editedItem.authCd !== 'A'"
                    color="indigo"
                    class="btn btn-popup"
                    @click="approveUser"
                  >
                    Approval
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <!-- 2단계 인증(OTP) 초기화 / 잠금 해제 (권한은 서버에서 재확인) -->
            <v-row
              v-if="
                (Number(this.$cookies.get('use-grade')) === 3 ||
                  Number(this.$cookies.get('use-grade')) === 9) &&
                  options.isEdit
              "
              class="ml-0 mr-0 mb-1"
            >
              <v-col cols="7" class="pl-1 pa-0">
                <v-label>{{ $t('msg.otp.adminTitle') }}</v-label>
              </v-col>
              <v-col cols="5" class="pl-1 pa-0"> </v-col>
              <v-col cols="12" class="pl-1 pa-0">
                <div class="btn-form-control text-right">
                  <v-btn
                    color="indigo"
                    class="btn btn-popup"
                    @click="$refs.otpAdminDialog.open({ usrId: editedItem.usrId })"
                  >
                    <v-icon x-small class="mr-1">fa fa-shield-alt</v-icon>
                    {{ $t('msg.otp.adminManage') }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
        <!-- [E]  Right Form-->
        <!-- [S]  Tree View-->
        <v-col cols="7" class="pr-0">
          <v-form ref="form" class="dialog-content form-user mr-0">
            <v-row class="ml-0 mr-0 mb-1">
              <v-col cols="12" class="pl-1 pa-0">
                <v-row class="ml-0 mr-0 mb-1">
                  <div class="flex-1 pl-5">
                    <v-btn @click="selectMenuAll()" x-small rounded color="warning">
                      <v-icon x-small class="mr-1">fa fa-ellipsis-v</v-icon>
                      {{ $t('lbl.users.addUser.menu') }}
                    </v-btn>
                  </div>
                  <div
                    class="flex justify-between pr-6 text-right"
                    style="max-width: 15rem; width: 15rem;"
                  >
                    <v-btn @click="selectSearchAll()" x-small rounded color="blue">
                      {{ $t('btn.common.search') }}
                    </v-btn>
                    <v-btn @click="selectManageAll()" x-small rounded color="indigo">
                      {{ $t('btn.common.manage') }}
                    </v-btn>
                  </div>
                </v-row>
                <v-row class="ml-0 mr-0 mb-1 user-mng-list">
                  <v-col cols="12" class="pl-1 pa-0">
                    <v-treeview
                      @input="selectMenu($event)"
                      :items="getMenuList"
                      :open-all="getOpenAll"
                      :value="selectMenus"
                      :readonly="!$auth.manage"
                      class="text-base custom-menu-button"
                      selectable
                      selected-color="warning"
                      item-key="id"
                      expand-icon="menu-tree fas fa-caret-down"
                      ref="menuTree"
                    >
                      <template v-slot:prepend="{ item }">
                        <icon-svg
                          v-if="item.icon"
                          :disabled="!$auth.manage"
                          size="26"
                          :iconName="item.name"
                        />
                      </template>
                      <template v-slot:label="{ item }">
                        <font style="font-size: 14px;">
                          {{ item.name }}
                        </font>
                      </template>
                      <template v-slot:append="{ item, selected }">
                        <div v-if="item.children === undefined" class="flex justify-between">
                          <v-checkbox
                            v-model="item.search"
                            :true-value="true"
                            :false-value="false"
                            :disabled="item.disabled || !selected || !$auth.manage"
                            class="m-0 p-0"
                            solo
                            hide-details
                          >
                          </v-checkbox>
                          <v-checkbox
                            v-model="item.manage"
                            :true-value="true"
                            :false-value="false"
                            :disabled="item.disabled || !selected || !$auth.manage"
                            class="m-0 p-0"
                            solo
                            color="indigo"
                            hide-details
                          >
                          </v-checkbox>
                        </div>
                      </template>
                    </v-treeview>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
        <!-- [E]  Tree View-->
      </v-row>
      <!-- [E]  Popup body-->
      <!-- [S]  Buttons-->
      <v-divider class="ml-0 mr-0 mt-0 mb-2 divder-popup" inset></v-divider>
      <v-row class="ml-0 mr-0">
        <v-col class="button-col action-col pa-0" lg="12">
          <div class="btn-form-control text-right">
            <v-btn class="btn btn-delete btn-popup" @click="closeWindow('btn-close')">
              {{ $t('btn.common.close') }}
            </v-btn>
            <v-btn
              class="btn btn-popup-search btn-popup"
              color="primary"
              @click="onSave"
              :disabled="!$auth.manage"
            >
              {{ $t('btn.common.save') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <!-- [E]  Buttons-->
    </v-card-text>

    <dialogWindow
      ref="addUserDialog"
      size="max"
      :info="checkDialogTitle"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="closeWindow('btn-close')"
    >
    </dialogWindow>
    <dialogWindow
      ref="approveUser"
      size="max"
      :detail="$t('msg.users.approveUser')"
      color="confirmation"
      :showCancel="true"
      @select-ok="onApproveUser"
    >
    </dialogWindow>
    <otp-admin-dialog ref="otpAdminDialog"></otp-admin-dialog>
  </v-card>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapState } from 'vuex';
// 2021.12.07 SPKA-304 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { hideProgress, showProgress } from '@/vue-dlb/utils/sys-util.js';
import OtpAdminDialog from '@/vue-caas/views/user/OtpAdminDialog.vue';

export default {
  components: {
    dialogWindow,
    IconSvg,
    OtpAdminDialog,
  },
  name: 'add-flatfile-layout-dialog',

  data: () => ({
    compOrgList: [],
    compList: [],
    checkDialogColor: 'validation',
    checkDialogTitle: '',
    checkDialogInfo: '',
    editedItem: {
      //verifyEmail: false,
      usrId: '',
      compId: '',
      usrNm: '',
      usrPwd: '',
      compAddr: '',
      compTelNo: '',
      langTpCd: '',
      selUiThmCd: 'light',
      gmtTmznCd: '',
      useGrdCd: '',
    },
    selUiThmCdList: [],
    gmtTmznCdList: [],
    menuList: [],
    openAll: false,
    useGrdCdList: [],
    langTpCdList: [],
    selectMenus: [],
    orgMngAuth: false,
    paramItem: '',
    options: '',
    indexType: '',
    tooltipWidth: 300,
    emailVrfSttList: [
      {
        value: 'W',
        text: 'Email Not Verified',
      },
      {
        value: 'C',
        text: 'Email Verified',
      },
      {
        value: 'A',
        text: 'Appoved',
      },
    ],
  }),

  created() {
    //set role true
    this.$auth.manage = true;
    if (window.theme) {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }

    let param = this.fileViewWindowParam[this.$route.params.id];
    (this.paramItem = param['paramItem']),
      (this.options = param['options']),
      (this.indexType = param['indexType']),
      // User Role
      this.$store.dispatch('caascommon/getComCdRoleList', { grpCd: 'C02' }).then(() => {
        this.useGrdCdList = this.$store.getters['caascommon/comCdList'];
      });

    // Screen Theme
    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'C03' }).then(() => {
      this.selUiThmCdList = this.$store.getters['caascommon/comCdList'];
    });

    // GMT Timezone
    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'C04' }).then(() => {
      this.gmtTmznCdList = this.$store.getters['caascommon/comCdList'];
    });

    // Language Type Code
    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'C05' }).then(() => {
      this.langTpCdList = this.$store.getters['caascommon/comCdList'];
    });

    this.$store.dispatch('getCompanyMngList', {}).then(() => {
      this.compOrgList = this.$store.getters.apicompanies;
      for (let i = 0; i < this.compOrgList.length; i += 1) {
        const comp = this.compOrgList[i];
        this.compList.push({ text: `${comp.compId}`, value: `${comp.compId}` });
      }
      if (this.compList.length === 1) {
        this.editedItem.compId = this.compList[0];
      }
    });
  },

  mounted() {
    this.orgMngAuth = this.$auth.manage;
    setTimeout(() => {
      document.getElementsByClassName('overlay-background')[0].style.display = 'none';
    }, 1000);
    if (JSON.stringify(this.paramItem) === '{}') {
      this.getDefaultMenuList();
    } else {
      this.$store.dispatch('getMenuList').then(() => {
        const tmpDefaultMenuList = this.$store.getters.menuList;
        const admMenuList = this._getAdmMenuList(tmpDefaultMenuList);
        const compAdmMenuList = this._getCompAdmMenuList(tmpDefaultMenuList);

        this.$store.dispatch('getUser', this.paramItem).then(() => {
          const userInfo = this.$store.getters.user;

          if (Number($cookies.get('use-grade')) < Number(userInfo.useGrdCd)) {
            this.$auth.manage = false;
          }

          Object.keys(userInfo).forEach((key) => {
            if (userInfo[key] === null) {
              userInfo[key] = '';
            }
          });
          this.editedItem = JSON.parse(JSON.stringify(userInfo));

          if (this.editedItem.menuAuth !== '') {
            const tmpOriMenuList = JSON.parse(JSON.stringify(this.$store.getters.menuList));
            const tmpMenuList = this._getUserMenuInfo(
              tmpOriMenuList,
              JSON.parse(this.editedItem.menuAuth),
            );
            const selectValues = [];

            for (let i = tmpMenuList.length - 1; i >= 0; i -= 1) {
              const tmpMenu = tmpMenuList[i];
              if (tmpMenuList[i].children === undefined) {
                if (
                  compAdmMenuList.indexOf(tmpMenu.id) > -1 &&
                  this.$cookies.get('comp-adminrepo-use-yn') === 'N'
                ) {
                  tmpMenuList.splice(i, 1);
                  continue;
                }
                if (
                  admMenuList.indexOf(tmpMenu.id) > -1 &&
                  Number(this.$cookies.get('use-grade')) < 3
                ) {
                  tmpMenuList.splice(i, 1);
                  continue;
                }

                if (admMenuList.indexOf(tmpMenu.id) > -1) {
                  tmpMenuList[i].disabled =
                    Number(this.editedItem.useGrdCd) < 3 || !this.$auth.manage;
                } else {
                  tmpMenuList[i].disabled = !this.$auth.manage;
                }
                if (admMenuList.indexOf(tmpMenu.id) > -1) {
                  if (Number(this.editedItem.useGrdCd) >= 3 && tmpMenu.select) {
                    selectValues.push(tmpMenu.id);
                  } else {
                    tmpMenuList[i].search = false;
                    tmpMenuList[i].manage = false;
                  }
                } else {
                  if (tmpMenu.select) {
                    selectValues.push(tmpMenu.id);
                  }
                }
              } else {
                let disabledCnt = 0;
                tmpMenuList[i].disabled = !this.$auth.manage;
                for (let j = tmpMenuList[i].children.length - 1; j >= 0; j -= 1) {
                  const tmpChild = tmpMenu.children[j];
                  if (tmpChild.children === undefined) {
                    if (
                      compAdmMenuList.indexOf(tmpChild.id) > -1 &&
                      this.$cookies.get('comp-adminrepo-use-yn') === 'N'
                    ) {
                      tmpMenuList[i].children.splice(j, 1);
                      continue;
                    }
                    if (
                      admMenuList.indexOf(tmpChild.id) > -1 &&
                      Number(this.$cookies.get('use-grade')) < 3
                    ) {
                      tmpMenuList[i].children.splice(j, 1);
                      continue;
                    }

                    if (admMenuList.indexOf(tmpChild.id) > -1) {
                      tmpMenuList[i].children[j].disabled =
                        Number(this.editedItem.useGrdCd) < 3 || !this.$auth.manage;
                      if (tmpMenuList[i].children[j].disabled) disabledCnt += 1;
                    } else {
                      tmpMenuList[i].children[j].disabled = !this.$auth.manage;
                    }
                    if (admMenuList.indexOf(tmpChild.id) > -1) {
                      if (Number(this.editedItem.useGrdCd) >= 3 && tmpChild.select) {
                        selectValues.push(tmpChild.id);
                      } else {
                        tmpMenuList[i].children[j].search = false;
                        tmpMenuList[i].children[j].manage = false;
                      }
                    } else {
                      if (tmpChild.select) {
                        selectValues.push(tmpChild.id);
                      }
                    }
                  } else {
                    tmpChild.disabled = !this.$auth.manage;
                    for (let k = tmpChild.children.length - 1; k >= 0; k -= 1) {
                      const tmpChildLvl3 = tmpChild.children[k];
                      if (
                        compAdmMenuList.indexOf(tmpChildLvl3.id) > -1 &&
                        this.$cookies.get('comp-adminrepo-use-yn') === 'N'
                      ) {
                        tmpChild.children.splice(j, 1);
                        continue;
                      }
                      if (
                        admMenuList.indexOf(tmpChildLvl3.id) > -1 &&
                        Number(this.$cookies.get('use-grade')) < 3
                      ) {
                        tmpChild.children.splice(j, 1);
                        continue;
                      }

                      if (admMenuList.indexOf(tmpChildLvl3.id) > -1) {
                        tmpChildLvl3.disabled =
                          Number(this.editedItem.useGrdCd) < 3 || !this.$auth.manage;
                        if (tmpChildLvl3.disabled) disabledCnt += 1;
                      } else {
                        tmpChildLvl3.disabled = !this.$auth.manage;
                      }
                      if (admMenuList.indexOf(tmpChildLvl3.id) > -1) {
                        if (Number(this.editedItem.useGrdCd) >= 3 && tmpChildLvl3.select) {
                          selectValues.push(tmpChildLvl3.id);
                        } else {
                          tmpChildLvl3.search = false;
                          tmpChildLvl3.manage = false;
                        }
                      } else {
                        if (tmpChildLvl3.select) {
                          selectValues.push(tmpChildLvl3.id);
                        }
                      }
                    }

                    if (tmpChild.children.length === 0) {
                      tmpMenuList.splice(i, 1);
                      continue;
                    }

                    if (tmpChild.children.length === disabledCnt) {
                      tmpMenuList[i].disabled = true;
                    }
                  }
                }

                if (tmpMenu.children.length === 0) {
                  tmpMenuList.splice(i, 1);
                  continue;
                }

                if (tmpMenu.children.length === disabledCnt) {
                  tmpMenuList[i].disabled = true;
                }
              }
            }
            this.selectMenus = selectValues;
            this.menuList = tmpMenuList;

            setTimeout(() => {
              this.$refs.menuTree.updateAll(true);
            }, 300);
          } else {
            this.$store
              .dispatch('getOwnerUser', { usrId: this.$cookies.get('user-id') })
              .then(() => {
                const userInfo = this.$store.getters.ownerUser;
                Object.keys(userInfo).forEach((key) => {
                  if (userInfo[key] === null) {
                    userInfo[key] = '';
                  }
                });

                if (userInfo.menuAuth !== '') {
                  const tmpOriMenuList = JSON.parse(userInfo.menuAuth);
                  const tmpMenuList = this._getUserMenuInfo(
                    tmpOriMenuList,
                    JSON.parse(userInfo.menuAuth),
                  );
                  const selectValues = [];

                  for (let i = tmpMenuList.length - 1; i >= 0; i -= 1) {
                    const tmpMenu = tmpMenuList[i];
                    if (tmpMenuList[i].children === undefined) {
                      if (
                        compAdmMenuList.indexOf(tmpMenu.id) > -1 &&
                        this.$cookies.get('comp-adminrepo-use-yn') === 'N'
                      ) {
                        tmpMenuList.splice(i, 1);
                        continue;
                      }
                      if (
                        admMenuList.indexOf(tmpMenu.id) > -1 &&
                        Number(this.$cookies.get('use-grade')) < 3
                      ) {
                        tmpMenuList.splice(i, 1);
                        continue;
                      }

                      if (admMenuList.indexOf(tmpMenu.id) > -1) {
                        tmpMenuList[i].disabled =
                          Number(userInfo.useGrdCd) < 3 || !this.$auth.manage;
                      } else {
                        tmpMenuList[i].disabled = !this.$auth.manage;
                      }
                      if (admMenuList.indexOf(tmpMenu.id) > -1) {
                        if (Number(userInfo.useGrdCd) >= 3 && tmpMenu.select) {
                          selectValues.push(tmpMenu.id);
                        } else {
                          tmpMenuList[i].search = false;
                          tmpMenuList[i].manage = false;
                        }
                      } else {
                        if (tmpMenu.select) {
                          selectValues.push(tmpMenu.id);
                        }
                      }
                    } else {
                      let disabledCnt = 0;
                      tmpMenuList[i].disabled = !this.$auth.manage;
                      for (let j = tmpMenuList[i].children.length - 1; j >= 0; j -= 1) {
                        const tmpChild = tmpMenu.children[j];
                        if (
                          compAdmMenuList.indexOf(tmpChild.id) > -1 &&
                          this.$cookies.get('comp-adminrepo-use-yn') === 'N'
                        ) {
                          tmpMenuList[i].children.splice(j, 1);
                          continue;
                        }
                        if (
                          admMenuList.indexOf(tmpChild.id) > -1 &&
                          Number(this.$cookies.get('use-grade')) < 3
                        ) {
                          tmpMenuList[i].children.splice(j, 1);
                          continue;
                        }

                        if (admMenuList.indexOf(tmpChild.id) > -1) {
                          tmpMenuList[i].children[j].disabled =
                            Number(userInfo.useGrdCd) < 3 || !this.$auth.manage;
                          if (tmpMenuList[i].children[j].disabled) disabledCnt += 1;
                        } else {
                          tmpMenuList[i].children[j].disabled = !this.$auth.manage;
                        }
                        if (admMenuList.indexOf(tmpChild.id) > -1) {
                          if (Number(userInfo.useGrdCd) >= 3 && tmpChild.select) {
                            selectValues.push(tmpChild.id);
                          } else {
                            tmpMenuList[i].children[j].search = false;
                            tmpMenuList[i].children[j].manage = false;
                          }
                        } else {
                          if (tmpChild.select) {
                            selectValues.push(tmpChild.id);
                          }
                        }
                      }

                      if (tmpMenu.children.length === 0) {
                        tmpMenuList.splice(i, 1);
                        continue;
                      }

                      if (tmpMenu.children.length === disabledCnt) {
                        tmpMenuList[i].disabled = true;
                      }
                    }
                  }
                  this.selectMenus = selectValues;
                  this.menuList = tmpMenuList;

                  setTimeout(() => {
                    this.$refs.menuTree.updateAll(true);
                  }, 300);
                } else {
                  this.getDefaultMenuList();
                }
              });
          }

          const tmpCompId = this.editedItem.compId;

          this.$store.dispatch('getCompany', { id: tmpCompId }).then(() => {
            const tmpUserInfo = JSON.parse(JSON.stringify(this.editedItem));
            this.editedItem = tmpUserInfo;
          });
        });
      });
    }
  },
  watch: {},

  computed: {
    ...mapState('analysis', {
      fileViewWindowParam: 'fileViewWindowParam',
    }),
    getMenuList() {
      return this.menuList;
    },
    getOpenAll() {
      return this.openAll;
    },
  },

  methods: {
    approveUser() {
      this.$refs.approveUser.dialog = true;
    },
    onApproveUser() {
      this.editedItem.authCd = 'A';
      this.onSave();
    },
    getDefaultMenuList() {
      this.$store.dispatch('getMenuList').then(() => {
        const tmpMenuList = this.$store.getters.menuList;
        const admMenuList = this._getAdmMenuList(tmpMenuList);
        const compAdmMenuList = this._getCompAdmMenuList(tmpMenuList);

        for (let i = tmpMenuList.length - 1; i >= 0; i -= 1) {
          const tmpMenu = tmpMenuList[i];
          if (tmpMenu.children === undefined) {
            if (
              compAdmMenuList.indexOf(tmpMenu.id) > -1 &&
              this.$cookies.get('comp-adminrepo-use-yn') === 'N'
            ) {
              tmpMenuList.splice(i, 1);
              continue;
            }
            if (
              admMenuList.indexOf(tmpMenu.id) > -1 &&
              Number(this.$cookies.get('use-grade')) < 3
            ) {
              tmpMenuList.splice(i, 1);
              continue;
            }
            tmpMenuList[i].select = false;
            tmpMenuList[i].search = false;
            tmpMenuList[i].manage = false;
            if (tmpMenu.admFlg === 'Y') {
              tmpMenuList[i].disabled = Number(this.editedItem.useGrdCd) < 3 || !this.$auth.manage;
            } else {
              tmpMenuList[i].disabled = !this.$auth.manage;
            }
          } else {
            let disabledCnt = 0;
            tmpMenuList[i].disabled = !this.$auth.manage;
            for (let j = tmpMenu.children.length - 1; j >= 0; j -= 1) {
              const tmpChild = tmpMenu.children[j];
              if (
                compAdmMenuList.indexOf(tmpChild.id) > -1 &&
                this.$cookies.get('comp-adminrepo-use-yn') === 'N'
              ) {
                tmpMenuList[i].children.splice(j, 1);
                continue;
              }
              if (
                admMenuList.indexOf(tmpChild.id) > -1 &&
                Number(this.$cookies.get('use-grade')) < 3
              ) {
                tmpMenuList[i].children.splice(j, 1);
                continue;
              }
              tmpMenuList[i].children[j].select = false;
              tmpMenuList[i].children[j].search = false;
              tmpMenuList[i].children[j].manage = false;
              if (tmpChild.admFlg === 'Y') {
                tmpMenuList[i].children[j].disabled =
                  Number(this.editedItem.useGrdCd) < 3 || !this.$auth.manage;
                if (tmpMenuList[i].children[j].disabled) disabledCnt += 1;
              } else {
                tmpMenuList[i].children[j].disabled = !this.$auth.manage;
              }
            }

            if (tmpMenu.children.length === 0) {
              tmpMenuList.splice(i, 1);
              continue;
            }

            if (tmpMenu.children.length === disabledCnt) {
              tmpMenuList[i].disabled = true;
            }
          }
        }

        this.menuList = tmpMenuList;
        setTimeout(() => {
          this.$refs.menuTree.updateAll(true);
        }, 300);
      });
    },
    onSave() {
      let formHasErrors = false;

      Object.keys(this.editedItem).forEach((key) => {
        if (this.$refs[key] !== undefined) {
          const validResult = !this.$refs[key].validate(true);
          formHasErrors = formHasErrors || validResult;
        }
      });

      if (!formHasErrors) {
        showProgress();
        this.editedItem.menuAuth = JSON.stringify(this.menuList);

        if (this.indexType > -1) {
          this.$store
            .dispatch('updateUser', this.editedItem)
            .then(() => {
              this.$refs.addUserDialog.dialog = true;
              this.checkDialogColor = 'success';
              this.checkDialogInfo = this.$t('msg.users.clickBtnSaveModifyUser');
              hideProgress();
            })
            .catch((err) => {
              this.$refs.addUserDialog.dialog = true;
              this.checkDialogColor = 'error';
              this.checkDialogInfo = `Fail to modify user. (Reason: ${err})`;
              hideProgress();
            });
        } else {
          this.$store
            .dispatch('checkUser', this.editedItem)
            .then(() => {
              const checkResult = this.$store.getters.chkUser;

              if (checkResult.usrId !== undefined) {
                this.$refs.addUserDialog.dialog = true;
                this.checkDialogColor = 'error';
                this.checkDialogInfo = 'This user is duplicated.';
              } else {
                this.$store
                  .dispatch('insertUser', this.editedItem)
                  .then(() => {
                    this.$refs.addUserDialog.dialog = true;
                    this.checkDialogColor = 'success';
                    this.checkDialogInfo = this.$t('msg.users.clickBtnSaveAddUser');
                    hideProgress();
                  })
                  .catch((err) => {
                    this.$refs.addUserDialog.dialog = true;
                    this.checkDialogColor = 'error';
                    this.checkDialogInfo = `Fail to add user. (Reason: ${err})`;
                    hideProgress();
                  });
              }
            })
            .catch((err) => {
              this.$refs.addUserDialog.dialog = true;
              this.checkDialogColor = 'error';
              this.checkDialogInfo = `Fail to check user. (Reason: ${err})`;
              hideProgress();
            });
        }
      }
    },
    selectMenu(value) {
      const tmpMenuList = JSON.parse(JSON.stringify(this.menuList));

      for (let i = 0; i < tmpMenuList.length; i += 1) {
        const tmpMenu = tmpMenuList[i];
        if (tmpMenu.children === undefined) {
          if (value.indexOf(tmpMenu.id) === -1) {
            if (!tmpMenu.disabled) {
              tmpMenuList[i].select = false;
              tmpMenuList[i].search = false;
              tmpMenuList[i].manage = false;
            }
          } else {
            if (!tmpMenu.disabled) {
              tmpMenuList[i].select = true;
              tmpMenuList[i].search = true;
            }
          }
        } else {
          for (let j = 0; j < tmpMenu.children.length; j += 1) {
            const tmpChild = tmpMenu.children[j];
            if (tmpChild.children === undefined) {
              if (value.indexOf(tmpChild.id) === -1) {
                if (!tmpChild.disabled) {
                  tmpMenuList[i].children[j].select = false;
                  tmpMenuList[i].children[j].search = false;
                  tmpMenuList[i].children[j].manage = false;
                }
              } else {
                if (!tmpChild.disabled) {
                  tmpMenuList[i].children[j].select = true;
                  tmpMenuList[i].children[j].search = true;
                }
              }
            } else {
              for (let k = 0; k < tmpChild.children.length; k += 1) {
                const tmpChildLvl3 = tmpChild.children[k];
                if (value.indexOf(tmpChildLvl3.id) === -1) {
                  if (!tmpChildLvl3.disabled) {
                    tmpMenuList[i].children[j].children[k].select = false;
                    tmpMenuList[i].children[j].children[k].search = false;
                    tmpMenuList[i].children[j].children[k].manage = false;

                    tmpMenuList[i].children[j].select = false;
                    tmpMenuList[i].children[j].search = false;
                    tmpMenuList[i].children[j].manage = false;
                  }
                } else {
                  if (!tmpChildLvl3.disabled) {
                    tmpMenuList[i].children[j].children[k].select = true;
                    tmpMenuList[i].children[j].children[k].search = true;

                    tmpMenuList[i].children[j].select = true;
                    // tmpMenuList[i].children[j].search = true;
                    // tmpMenuList[i].children[j].manage = true;
                  }
                }
              }
            }
          }
        }
      }
      // Update data(execute computed method). If doing reference copy, does not updated.
      this.menuList = tmpMenuList;
    },
    selectMenuAll() {
      this._selectAll('select', true);
    },
    selectSearchAll() {
      this._selectAll('search', true);
    },
    selectManageAll() {
      this._selectAll('manage', true);
    },
    _selectAll(btnTp, isClickBtn) {
      // For data copy. Do not reference copy.
      const tmpMenuList = JSON.parse(JSON.stringify(this.menuList));

      let menuLength = isClickBtn ? 0 : 100;
      let currentLength = 0;
      if (btnTp === 'select') {
        for (let i = 0; i < tmpMenuList.length; i += 1) {
          const tmpMenu = tmpMenuList[i];
          if (tmpMenu.children === undefined) {
            if (!tmpMenu.disabled) {
              menuLength += 1;
              if (tmpMenu[btnTp]) {
                currentLength += 1;
              }
            }
          } else {
            for (let j = 0; j < tmpMenu.children.length; j += 1) {
              const tmpChild = tmpMenu.children[j];
              if (!tmpChild.disabled) {
                menuLength += 1;
                if (tmpChild[btnTp]) {
                  currentLength += 1;
                }
              }
            }
          }
        }

        if (menuLength === currentLength) {
          const disabledMenus = [];
          for (let i = 0; i < tmpMenuList.length; i += 1) {
            const tmpMenu = tmpMenuList[i];
            if (tmpMenu.children === undefined) {
              if (!tmpMenu.disabled) {
                tmpMenuList[i][btnTp] = false;
              } else {
                // disabled 된 메뉴 ID를 array 변수에 추가
                disabledMenus.push(tmpMenu.id);
              }
            } else {
              for (let j = 0; j < tmpMenu.children.length; j += 1) {
                const tmpChild = tmpMenu.children[j];
                if (!tmpChild.disabled) {
                  tmpMenuList[i].children[j][btnTp] = false;
                } else {
                  // disabled 된 메뉴 ID를 array 변수에 추가
                  disabledMenus.push(tmpChild.id);
                }
              }
            }
          }

          for (let k = disabledMenus.length - 1; k >= 0; k -= 1) {
            const disabledMenu = disabledMenus[k];
            if (this.selectMenus.indexOf(disabledMenu) === -1) {
              // disabled 된 메뉴 중에 기존에 select가 되어 있던 메뉴인지 확인하여, select 되지 않았던 메뉴는 제거
              disabledMenus.splice(k, 1);
            }
          }
          // disabled 된 메뉴중에 선택이 되어 있었던 메뉴는, 기존에 선택된 상태로 반영함
          this.selectMenus = disabledMenus;
        } else {
          for (let i = 0; i < tmpMenuList.length; i += 1) {
            const tmpMenu = tmpMenuList[i];
            if (tmpMenu.children === undefined) {
              if (!tmpMenu.disabled) {
                tmpMenuList[i][btnTp] = true;
                this.selectMenus.push(tmpMenu.id);
              }
            } else {
              for (let j = 0; j < tmpMenu.children.length; j += 1) {
                const tmpChild = tmpMenu.children[j];
                if (!tmpChild.disabled) {
                  tmpMenuList[i].children[j][btnTp] = true;
                  this.selectMenus.push(tmpChild.id);
                }
              }
            }
          }
        }
      } else {
        for (let i = 0; i < tmpMenuList.length; i += 1) {
          const tmpMenu = tmpMenuList[i];
          if (tmpMenu.children === undefined) {
            if (!tmpMenu.disabled) {
              if (tmpMenu.select) {
                menuLength += 1;
                if (tmpMenu[btnTp]) {
                  currentLength += 1;
                }
              }
            }
          } else {
            for (let j = 0; j < tmpMenu.children.length; j += 1) {
              const tmpChild = tmpMenu.children[j];
              if (tmpChild.children === undefined) {
                if (!tmpChild.disabled) {
                  if (tmpChild.select) {
                    menuLength += 1;
                    if (tmpChild[btnTp]) {
                      currentLength += 1;
                    }
                  }
                }
              } else {
                for (let k = 0; k < tmpChild.children.length; k += 1) {
                  const tmpChildLvl3 = tmpChild.children[k];
                  if (!tmpChildLvl3.disabled) {
                    if (tmpChildLvl3.select) {
                      menuLength += 1;
                      if (tmpChildLvl3[btnTp]) {
                        currentLength += 1;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        if (menuLength === currentLength) {
          for (let i = 0; i < tmpMenuList.length; i += 1) {
            const tmpMenu = tmpMenuList[i];
            if (tmpMenu.children === undefined) {
              if (!tmpMenu.disabled) {
                if (tmpMenu.select) {
                  tmpMenuList[i][btnTp] = false;
                }
              }
            } else {
              for (let j = 0; j < tmpMenu.children.length; j += 1) {
                const tmpChild = tmpMenu.children[j];
                if (tmpChild.children === undefined) {
                  if (!tmpChild.disabled) {
                    if (tmpChild.select) {
                      tmpMenuList[i].children[j][btnTp] = false;
                    }
                  }
                } else {
                  for (let k = 0; k < tmpChild.children.length; k += 1) {
                    const tmpChildLvl3 = tmpMenu.children[k];
                    if (!tmpChildLvl3.disabled) {
                      if (tmpChildLvl3.select) {
                        tmpMenuList[i].children[j].children[k][btnTp] = false;
                      }
                    }
                  }
                }
              }
            }
          }
        } else {
          for (let i = 0; i < tmpMenuList.length; i += 1) {
            const tmpMenu = tmpMenuList[i];
            if (tmpMenu.children === undefined) {
              if (!tmpMenu.disabled) {
                if (tmpMenu.select) {
                  tmpMenuList[i][btnTp] = true;
                }
              }
            } else {
              for (let j = 0; j < tmpMenu.children.length; j += 1) {
                const tmpChild = tmpMenu.children[j];
                if (tmpChild.children === undefined) {
                  if (!tmpChild.disabled) {
                    if (tmpChild.select) {
                      tmpMenuList[i].children[j][btnTp] = true;
                    }
                  }
                } else {
                  for (let k = 0; k < tmpChild.children.length; k += 1) {
                    const tmpChildLvl3 = tmpMenu.children[k];
                    if (!tmpChildLvl3.disabled) {
                      if (tmpChildLvl3.select) {
                        tmpMenuList[i].children[j].children[k][btnTp] = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      // alert(`menuLength: ${menuLength}\ncurrentLength: ${currentLength}`);
      // Update data(execute computed method). If doing reference copy, does not updated.
      this.menuList = tmpMenuList;
    },

    changeRole(roleCd) {
      this._setDisabled(roleCd);
      if (roleCd === '1') {
        this._selectAll('select');

        for (let i = 0; i < this.menuList.length; i += 1) {
          const tmpMenu = this.menuList[i];
          if (tmpMenu.children === undefined) {
            if (tmpMenu.select) {
              this.menuList[i].manage = false;
            }
          } else {
            for (let j = 0; j < tmpMenu.children.length; j += 1) {
              const tmpChild = tmpMenu.children[j];
              if (tmpChild.select) {
                this.menuList[i].children[j].manage = false;
              }
            }
          }
        }
      } else if (roleCd === '2' || roleCd === '3') {
        this._selectAll('select');
        this._selectAll('manage');
      }
    },

    _setDisabled(roleCd) {
      const tmpMenuList = JSON.parse(JSON.stringify(this.menuList));

      for (let i = 0; i < tmpMenuList.length; i += 1) {
        const tmpMenu = tmpMenuList[i];
        if (tmpMenu.children === undefined) {
          if (Number(roleCd) < 3 && tmpMenu.admFlg === 'Y') {
            tmpMenuList[i].disabled = true;

            tmpMenuList[i].select = false;
            tmpMenuList[i].search = false;
            tmpMenuList[i].manage = false;

            if (this.selectMenus.indexOf(tmpMenu.id) > -1) {
              const idx = this.selectMenus.indexOf(tmpMenu.id);
              this.selectMenus.splice(idx, 1);
            }
          } else if (tmpMenuList[i].disabled) {
            tmpMenuList[i].disabled = false;
          }
        } else {
          let disabledCnt = 0;
          for (let j = 0; j < tmpMenu.children.length; j += 1) {
            const tmpChild = tmpMenu.children[j];
            if (Number(roleCd) < 3 && tmpChild.admFlg === 'Y') {
              tmpMenuList[i].children[j].disabled = true;

              tmpMenuList[i].children[j].select = false;
              tmpMenuList[i].children[j].search = false;
              tmpMenuList[i].children[j].manage = false;
              disabledCnt += 1;

              if (this.selectMenus.indexOf(tmpChild.id) > -1) {
                const idx = this.selectMenus.indexOf(tmpChild.id);
                this.selectMenus.splice(idx, 1);
              }
            } else if (tmpMenuList[i].children[j].disabled) {
              tmpMenuList[i].children[j].disabled = false;
            }
          }

          if (disabledCnt === tmpMenu.children.length) {
            tmpMenuList[i].disabled = true;
          } else if (tmpMenuList[i].disabled) {
            tmpMenuList[i].disabled = false;
          }
        }
      }

      this.menuList = tmpMenuList;
    },

    _getAdmMenuList(tmpDefaultMenuList) {
      const admMenuList = [];
      for (let i = 0; i < tmpDefaultMenuList.length; i += 1) {
        const tmpMenu = tmpDefaultMenuList[i];
        if (tmpMenu.children === undefined) {
          if (tmpMenu.admFlg === 'Y') {
            admMenuList.push(tmpMenu.id);
          }
        } else {
          let admMenuCnt = 0;
          for (let j = 0; j < tmpMenu.children.length; j += 1) {
            const tmpChild = tmpMenu.children[j];
            if (tmpChild.admFlg === 'Y') {
              admMenuList.push(tmpChild.id);
              admMenuCnt += 1;
            }
          }

          if (tmpMenu.children.length === admMenuCnt) {
            admMenuList.push(tmpMenu.id);
          }
        }
      }
      return admMenuList;
    },

    _getCompAdmMenuList(tmpDefaultMenuList) {
      const admMenuList = [];
      for (let i = 0; i < tmpDefaultMenuList.length; i += 1) {
        const tmpMenu = tmpDefaultMenuList[i];
        if (tmpMenu.children === undefined) {
          if (tmpMenu.compAdmFlg === 'Y') {
            admMenuList.push(tmpMenu.id);
          }
        } else {
          let admMenuCnt = 0;
          for (let j = 0; j < tmpMenu.children.length; j += 1) {
            const tmpChild = tmpMenu.children[j];
            if (tmpChild.compAdmFlg === 'Y') {
              admMenuList.push(tmpChild.id);
              admMenuCnt += 1;
            }
          }

          if (tmpMenu.children.length === admMenuCnt) {
            admMenuList.push(tmpMenu.id);
          }
        }
      }
      return admMenuList;
    },

    _getUserMenuInfo(oriMenus, usrMenus) {
      for (let i = 0; i < oriMenus.length; i += 1) {
        let menuChg = false;
        const oriMenu = oriMenus[i];
        for (let j = 0; j < usrMenus.length; j += 1) {
          const usrMenu = usrMenus[j];

          if (oriMenu.id === usrMenu.id) {
            if (oriMenu.children === undefined) {
              oriMenus[i].select = usrMenu.select;
              oriMenus[i].search = usrMenu.search;
              oriMenus[i].manage = usrMenu.manage;
              oriMenus[i].disabled = usrMenu.disabled;
              menuChg = true;
            } else {
              for (let k = 0; k < oriMenu.children.length; k += 1) {
                let childChg = false;
                const oriChild = oriMenu.children[k];
                for (let l = 0; l < usrMenu.children.length; l += 1) {
                  const usrChild = usrMenu.children[l];
                  if (oriChild.id === usrChild.id) {
                    if (oriChild.children === undefined) {
                      oriMenus[i].children[k].select = usrChild.select;
                      oriMenus[i].children[k].search = usrChild.search;
                      oriMenus[i].children[k].manage = usrChild.manage;
                      oriMenus[i].children[k].disabled = usrChild.disabled;
                      childChg = true;
                    } else {
                      // console.log('Menu lvl 3', oriChild.children);
                      for (let m = 0; m < oriChild.children.length; m += 1) {
                        let level3Chg = false;
                        const oriChildLvl3 = oriChild.children[m];
                        for (let n = 0; n < usrChild.children.length; n += 1) {
                          const usrChildLvl3 = usrChild.children[n];
                          // console.log(oriChildLvl3, usrChildLvl3);
                          if (oriChildLvl3.id === usrChildLvl3.id) {
                            oriMenus[i].children[k].children[m].select = usrChildLvl3.select;
                            oriMenus[i].children[k].children[m].search = usrChildLvl3.search;
                            oriMenus[i].children[k].children[m].manage = usrChildLvl3.manage;
                            oriMenus[i].children[k].children[m].disabled = usrChildLvl3.disabled;
                            level3Chg = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      // console.log('Khanh check', oriMenus);
      return oriMenus;
    },

    selectCountry() {
      const langTpCd = this.editedItem.langTpCd;
      for (let i = 0; i < this.langTpCdList.length; i += 1) {
        const langTpCdObj = this.langTpCdList[i];
        if (langTpCd === langTpCdObj.value) {
          this.editedItem.gmtTmznCd = langTpCdObj.cdDesc === null ? '' : langTpCdObj.cdDesc;
          break;
        }
      }
    },
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
  },
};
</script>
<style lang="scss">
.user-data-section {
  padding: 20px 50px 30px 50px !important;
  .dialog-content.form-user {
    padding: 20px 15px 15px 15px;
  }
}
.theme--dark .user-data-section {
  background-color: #3b3e49;
  .dialog-content.form-user {
    background-color: #292c35 !important;
  }
}
.theme--light .user-data-section {
  background-color: #ffffff;
  .dialog-content.form-user {
    background: #edf0f7;
    border: 1px solid #edf0f7;
    .v-label {
      color: #000000;
    }
  }
}
.theme--light .process-text-info {
  color: #000000;
}
.theme--dark
  .user-data-section
  .dialog-content.form-user
  .v-treeview-node__content
  .component
  path {
  stroke: #ffeb3b;
}
.theme--dark .user-data-section .dialog-content.form-user .v-treeview-node__content path {
  fill: #ffeb3b;
}
.theme--dark .user-data-section .dialog-content.form-user .v-treeview-node__content rect {
  fill: #ffeb3b;
}
.custom-menu-button > .v-treeview-node--leaf .v-treeview-node__level {
  display: none !important;
}
.custom-menu-button .v-treeview-node--leaf .v-treeview-node__level:nth-of-type(2) {
  display: none !important;
}
.custom-menu-button .v-treeview-node__level {
  width: 40px !important;
}
.custom-menu-button .v-treeview-node__append {
  width: 12rem !important;
}
.custom-menu-button .v-treeview-node__prepend {
  min-width: 0 !important;
}
.user-mng-list {
  overflow-y: scroll !important;
  height: 514px;
}
</style>
